import moment from 'moment';
import { DateUtil, LocalDateUtil } from '@xengage/gw-portals-util-js';

/**
 * Module that returns the current date. Can be replaced with
 * another implementation, for example if you needed to time travel and return
 * a different current date
 */

/**
 * @param {Date} aDate to format
 * @returns {String} formmated date to "MMMM DD YYYY" ie. "May 5 2021"
 */
function getDateFormatMMMMDDYYYY(aDate) {
    if (aDate === null || aDate === undefined) {
        console.warn('Unable to format empty date');
        return;
    }
    const dateFormat = 'MMMM DD YYYY';
    // eslint-disable-next-line consistent-return
    return moment(aDate).format(dateFormat);
}


/**
 * @param {Date} aDate to format
 * @returns {String} formmated date to "MM/DD/YYYY" string ie. "05/13/2021"
 */
function formatDateWMIC(aDate) {
    const date = new Date(aDate);
    const year = DateUtil.getYear(date);
    const month = DateUtil.getMonth(date);
    const day = DateUtil.getDate(date);
    return `${month}/${day}/${year}`;
}

/**
 * @param {Date} aDate that need to add days to it
 * @param {Number} daysToAdd is how many days to add to the target date
 * @returns {Date} a new date that has added days
 */
function addDays(aDate, daysToAdd) {
    aDate.setDate(aDate.getDate() + daysToAdd);
    return aDate;
}

/**
 * @param {localDateDTO} aLocalDate to convert to Date
 * @returns {Date} a date object that be converted from LocalDateDTO
 */
function localDateDTOToDate(aLocalDate) {
    return new Date(aLocalDate.year, aLocalDate.month, aLocalDate.day);
}

/**
 * 
 * @param {Date} aDate Date to format
 * @param {IntlContext} intl IntlContext to be used for formatting the date.
 * @returns Date appropriately formatted and in the correct timezone.
 */
function formatDateIntl(aDate, intl) {
    const d = new Date(aDate);
    if (isNaN(d.getTime())) {
        logger.warn(`Invalid date format for ${aDate}`);
        return null;
    }

    const dateObject = {
        year: d.getUTCFullYear(),
        month: d.getUTCMonth(),
        day: d.getUTCDate()
    };

    const midnightDate = LocalDateUtil.toMidnightDate(dateObject);
    return intl.formatDate(midnightDate, { year: 'numeric', month: '2-digit', day: '2-digit' });
}

function addYears(date, yearsToAdd) {
    date.setFullYear(date.getFullYear() + yearsToAdd);
    return date;
}

export default {
    // Platform DateUtil functions
    currentDate: DateUtil.currentDate,
    currentDateAtMidnight: DateUtil.currentDateAtMidnight,
    getYear: DateUtil.getYear,
    getMonth: DateUtil.getMonth,
    getDate: DateUtil.getDate,
    getHour: DateUtil.getHour,
    trimToMidnight: DateUtil.trimToMidnight,
    addHours: DateUtil.addHours,
    getCurrentTimeTrimmedToHour: DateUtil.getCurrentTimeTrimmedToHour,
    compareIgnoreTime: DateUtil.compareIgnoreTime,
    dateYearsAgo: DateUtil.dateYearsAgo,
    // Wawanesa DateUtil functions
    getDateFormatMMMMDDYYYY,
    formatDateWMIC,
    formatDateIntl,
    localDateDTOToDate,
    addDays,
    addYears
};
